// Component: src/theme/sections/stores.liquid

import { debounce } from "@app/utils/debounce";

const init = () => {
  const windowHeight = window.innerHeight;
  const sections = document.querySelectorAll(".section-stores");

  sections.forEach((section) => {
    const prevSection = section.previousElementSibling;
    const height = prevSection?.getBoundingClientRect().height;

    section.style.backgroundColor = `transparent`;
    prevSection.style.position = `sticky`;
    prevSection.style.zIndex = `-1`;

    if (prevSection && height && height > windowHeight) {
      prevSection.style.top = `-${height - windowHeight + SECTION_BUFFER}px`;
    } else {
      prevSection.style.top = `0px`
    }
  });
}

const SECTION_BUFFER = 30;

document.addEventListener("DOMContentLoaded", () => {
  init();
});

const initDebounced = debounce(init, 1000);
window.addEventListener("resize", () => {
  initDebounced();
});
